import React from 'react';
import './buttons.css'

export default props => 
    <button className={`
            button
            ${props.btnSubmit ? 'btn-submit' : ''}
            ${props.btnProduct ? 'btn-product' : ''}
            ${props.destaque ? 'btn-product-destaque' : ''}
            ${props.btnSejaParceiro ? 'btn-seja-parceiro' : ''}
        `}

        onClick={e =>  props.click && props.click(props.function)}
    >
        {props.labelBtn}
    </button>
